import { render } from "./PurchaseSupplies.vue?vue&type=template&id=540ecf2c"
import script from "./PurchaseSupplies.vue?vue&type=script&lang=js"
export * from "./PurchaseSupplies.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__